import axios from 'axios';

// In dev: proxy in package.json sends /api/* to localhost:8000
// In prod: REACT_APP_API_URL is baked in at build time
const baseURL = process.env.REACT_APP_API_URL || '/api';

const client = axios.create({
  baseURL,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
  },
});

client.interceptors.request.use(
  (config) => {
    try {
      const tg = (window as any).Telegram?.WebApp;
      if (tg?.initData) {
        config.headers['X-Telegram-Init-Data'] = tg.initData;
      }
    } catch {}
    return config;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      console.error('API Error:', error.response.status, error.response.data);
    } else if (error.request) {
      console.error('Network Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default client;
